import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    padding: 5vw 0vw 5vw 0;

    width: 100%;
`;

export const GridContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4vw;
    margin: 0 15vw;
    
    background-color: #f7f3ec;

    text-align: center;

    /* Tablet: height */
    @media (min-width: 641px)  {
        // flex-direction: column;
        justify-content: center;
        flex-wrap: wrap;
        margin: 0 5vw;
    }

    /* Desktop: min-height */
    @media (min-width: 1024px) {
        gap: 1vw;
    }
`

export const ZorgProfTitle = styled.div`
    color: white;
    text-transform: uppercase;
    background-color: #114D55;
    font-size: 0.8em;
    
    padding: 0.4em 0.2em 0.2em 0.2em;

    /* Tablet: height */
    @media (min-width: 641px)  {
    }

    /* Desktop: min-height */
    @media (min-width: 1025px) {
        font-size: 1.5em;
    }
`;

export const GridTile = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5vw;
    text-decoration: none;
    width: 33vw;

    &:hover ${ZorgProfTitle} {
        background-color: white;
        color: #114D55;
    }

    /* Tablet: height */
    @media (min-width: 641px)  {
        width: 18vw;
    }

    /* Desktop: min-height */
    @media (min-width: 1024px) {
        width: 11vw;
    }
`;

export const ZorgProfImg = styled.img`
    width: 100%;
`;
